module.exports = __webpack_public_path__ + "img/es-mb-s6.400e277f.png";